import { render, staticRenderFns } from "./ConfigureAndPublishTab.vue?vue&type=template&id=7b745a51&"
import script from "./ConfigureAndPublishTab.vue?vue&type=script&lang=js&"
export * from "./ConfigureAndPublishTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ConfigureAndPublishTab.vue"
export default component.exports